import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.292 8.292a1 1 0 1 0 1.416 1.416L12 5.414l4.292 4.294a1 1 0 1 0 1.416 -1.416l-5 -5a1 1 0 0 0 -1.416 0l-5 5Zm11.416 7.416a1 1 0 1 0 -1.416 -1.416L12 18.586 7.708 14.292a1 1 0 1 0 -1.416 1.416l5 5a1 1 0 0 0 1.416 0l5 -5Z"
      fill={fill}
    />
  </g>
);

export default Icon;
